.bj{right:0px;}